import { __assign, __generator, __spreadArray } from "tslib";
import { all, select, put, call, takeLatest, takeEvery, delay, } from 'redux-saga/effects';
import { normalize } from 'normalizr';
import { withOffset, withCursor, selectors } from '../../Stream';
import { NotificationType } from '../../Notifications';
import { ResourceType } from '../../types/resource';
import { getCurrentUserId, getIsLoggedIn, getIsMobile, } from '../../publicSession/selectors';
import { restrictLoggedOut } from '../../redux/loggedout';
import { putEntities } from '../../redux/entities/actions';
import { deviationSchema } from '../../redux/normalizr/schemas/deviation';
import { hidePanel } from '../../DeviationPage/redux/actions';
import { request } from '../../xhr';
import { BiEventType, ReferralType } from '@wix/da-bi/pkg/constants';
import { logBiEvent } from '../../biLogger/redux/saga';
import { getPageBiContext } from '../../biLogger/redux/selectors';
import { groupFoldersStreamType, groupsStreamType } from './constants';
import { FolderType, } from './types';
import { addToGroupFolderFail, addToGroupFolderSuccess, addToGroupFolder, initGroupsPanel, } from './actions';
import { getFolderStreamId, getGroupsStreamId } from './helpers';
import { fetchGroupFolders, addDeviationToGroupFolder } from './xhr';
import { addNotificationToQueue } from '../../Notifications/redux/actionCreators';
import { getDeviationNotificationQueue } from '../../DeviationPage/redux/helpers';
var cursorFetchAction = withCursor.actions.STREAM__WITH_CURSOR__FETCH;
var offsetFetchAction = withOffset.actions.STREAM__WITH_OFFSET__FETCH;
export var GROUPS_PER_FETCH = 24;
export var GROUP_FOLDERS_PER_FETCH = 24;
// /developers/console/papi/da-deviation/dadeviation_groups/262c19bc5c3ed1ed9e6e1e55828095d4
var GROUPS_ENDPOINT_URL = 'deviation/groups';
export function handleInit() {
    var isLoggedIn, streamId, userId, existingStreamParams;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _a.sent();
                if (!isLoggedIn) {
                    return [2 /*return*/];
                }
                streamId = getGroupsStreamId();
                return [4 /*yield*/, select(getCurrentUserId)];
            case 2:
                userId = _a.sent();
                return [4 /*yield*/, select(selectors.getStreamParams, streamId)];
            case 3:
                existingStreamParams = _a.sent();
                if (existingStreamParams && existingStreamParams.userId === userId) {
                    // already initialized, we're good
                    return [2 /*return*/];
                }
                return [4 /*yield*/, put(withCursor.actions.initialize({
                        streamId: streamId,
                        itemsPerFetch: GROUPS_PER_FETCH,
                        items: [],
                        hasMore: true,
                        streamParams: {
                            type: groupsStreamType,
                            userId: userId,
                        },
                    }))];
            case 4:
                _a.sent();
                return [4 /*yield*/, put(withCursor.actions.fetch(streamId))];
            case 5:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
function handleFetch(_a) {
    var streamParams, _b;
    var streamId = _a.streamId;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(selectors.getStreamParams, streamId)];
            case 1:
                streamParams = _c.sent();
                if (!streamParams) {
                    return [2 /*return*/];
                }
                _b = streamParams.type;
                switch (_b) {
                    case groupsStreamType: return [3 /*break*/, 2];
                    case groupFoldersStreamType: return [3 /*break*/, 4];
                }
                return [3 /*break*/, 6];
            case 2: return [4 /*yield*/, call(handleFetchGroups, streamId, streamParams)];
            case 3:
                _c.sent();
                return [3 /*break*/, 6];
            case 4: return [4 /*yield*/, call(handleFetchFolders, streamId, streamParams)];
            case 5:
                _c.sent();
                return [3 /*break*/, 6];
            case 6: return [2 /*return*/];
        }
    });
}
function handleFetchFolders(streamId, streamParams) {
    var isLoggedIn, result;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _a.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.ADD_TO_GROUP }))];
            case 2:
                _a.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, delay(300)];
            case 4:
                _a.sent();
                return [4 /*yield*/, call(fetchGroupFolders, streamParams.groupId, streamParams.folderType)];
            case 5:
                result = _a.sent();
                if (!!result) return [3 /*break*/, 7];
                return [4 /*yield*/, put(withOffset.actions.fetchFailure({
                        streamId: streamId,
                        errorMsg: 'Failed to fetch folders',
                    }))];
            case 6:
                _a.sent();
                return [2 /*return*/];
            case 7: return [4 /*yield*/, put(withOffset.actions.fetchSuccessDeduped({
                    streamId: streamId,
                    dedupeFunction: function (item, existingItems) {
                        return !existingItems.some(function (i) { return i.folderId === item.folderId; });
                    },
                    items: result.results,
                    hasMore: false,
                }))];
            case 8:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
export function handleFetchGroups(streamId, streamParams) {
    var isLoggedIn, cursor, result;
    var _a;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0: return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _b.sent();
                if (!!isLoggedIn) return [3 /*break*/, 3];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.ADD_TO_GROUP }))];
            case 2:
                _b.sent();
                return [2 /*return*/];
            case 3: return [4 /*yield*/, delay(300)];
            case 4:
                _b.sent();
                return [4 /*yield*/, select(withCursor.selectors.getCursor, streamId)];
            case 5:
                cursor = _b.sent();
                return [4 /*yield*/, call(request, {
                        method: 'get',
                        url: GROUPS_ENDPOINT_URL,
                        params: {
                            cursor: cursor,
                            limit: GROUPS_PER_FETCH,
                        },
                    }, fakeFetchGroups)];
            case 6:
                result = _b.sent();
                if (!!result) return [3 /*break*/, 8];
                return [4 /*yield*/, put(withCursor.actions.fetchFailure({
                        streamId: streamId,
                        errorMsg: 'Failed to fetch groups',
                    }))];
            case 7:
                _b.sent();
                return [2 /*return*/];
            case 8: 
            // update groups stream, and init folder streams for all fetched groups
            return [4 /*yield*/, all(__spreadArray([
                    put(withCursor.actions.fetchSuccessDeduped({
                        streamId: streamId,
                        dedupeFunction: function (item, existingItems) {
                            return !existingItems.some(function (i) { return i.userId === item.userId; });
                        },
                        items: result.results,
                        hasMore: ((_a = result.results) === null || _a === void 0 ? void 0 : _a.length) >= GROUPS_PER_FETCH,
                        cursor: result.cursor,
                    }))
                ], result.results
                    .map(function (group) {
                    return [FolderType.Gallery, FolderType.Collection].map(function (folderType) {
                        var folderStreamId = getFolderStreamId(folderType, group.userId);
                        var folderStreamParams = {
                            type: groupFoldersStreamType,
                            folderType: folderType,
                            userId: streamParams.userId,
                            groupId: group.userId,
                        };
                        return put(withOffset.actions.initialize({
                            streamId: folderStreamId,
                            itemsPerFetch: GROUP_FOLDERS_PER_FETCH,
                            items: [],
                            hasMore: true,
                            streamParams: folderStreamParams,
                        }));
                    });
                })
                    .reduce(function (flattened, current) { return __spreadArray(__spreadArray([], flattened, true), current, true); }, []), true))];
            case 9:
                // update groups stream, and init folder streams for all fetched groups
                _b.sent();
                return [2 /*return*/];
        }
    });
}
function fakeFetchGroups() {
    if (process.env.NODE_ENV !== 'production') {
        // eslint-disable-next-line global-require
        var groups = require('@wix/da-sample-data').groups;
        return {
            results: groups,
        };
    }
    return {
        results: [],
    };
}
function handleAddToGroup(_a) {
    var isLoggedIn, biContext, result, notification, updatedDeviation, entities, isMobile;
    var _b = _a.payload, group = _b.group, deviation = _b.deviation, groupFolderId = _b.groupFolderId, actionbarType = _b.actionbarType;
    return __generator(this, function (_c) {
        switch (_c.label) {
            case 0: return [4 /*yield*/, select(getIsLoggedIn)];
            case 1:
                isLoggedIn = _c.sent();
                return [4 /*yield*/, select(getPageBiContext)];
            case 2:
                biContext = _c.sent();
                if (!!isLoggedIn) return [3 /*break*/, 4];
                return [4 /*yield*/, put(restrictLoggedOut({ restrictedActionName: ReferralType.ADD_TO_GROUP }))];
            case 3:
                _c.sent();
                return [2 /*return*/];
            case 4: return [4 /*yield*/, call(addDeviationToGroupFolder, groupFolderId, deviation.deviationId)];
            case 5:
                result = _c.sent();
                notification = {
                    success: result.success,
                    error: result.errorDetails,
                    needsVote: result.needsVote,
                    deviation: deviation,
                    group: group,
                    groupFolderId: groupFolderId,
                    actionbarType: actionbarType,
                };
                if (!!result.success) return [3 /*break*/, 7];
                return [4 /*yield*/, put(addToGroupFolderFail(deviation.deviationId, groupFolderId))];
            case 6:
                _c.sent();
                return [3 /*break*/, 10];
            case 7: return [4 /*yield*/, put(addToGroupFolderSuccess(deviation.deviationId, groupFolderId, !!result.needsVote))];
            case 8:
                _c.sent();
                if (!(!result.needsVote &&
                    typeof result.deviationGroupCount !== undefined &&
                    deviation.extended &&
                    deviation.extended.stats)) return [3 /*break*/, 10];
                updatedDeviation = __assign(__assign({}, deviation), { extended: __assign(__assign({}, deviation.extended), { stats: __assign(__assign({}, deviation.extended.stats), { groups: deviation.extended.stats.groups + 1 }) }) });
                entities = normalize(updatedDeviation, deviationSchema).entities;
                return [4 /*yield*/, put(putEntities({ entities: entities }))];
            case 9:
                _c.sent();
                _c.label = 10;
            case 10: return [4 /*yield*/, delay(1000)];
            case 11:
                _c.sent();
                return [4 /*yield*/, put(hidePanel('groups'))];
            case 12:
                _c.sent();
                return [4 /*yield*/, call(logBiEvent, __assign(__assign({}, biContext), { evid: BiEventType.ADD_TO_GROUP_FOLDER_SELECT, deviationid: deviation.deviationId, groupid: group.useridUuid, typeid: groupFolderId.type === FolderType.Collection
                            ? ResourceType.COLLECTION
                            : ResourceType.GALLERY, itemid: groupFolderId.folderId }))];
            case 13:
                _c.sent();
                return [4 /*yield*/, select(getIsMobile)];
            case 14:
                isMobile = _c.sent();
                return [4 /*yield*/, put(addNotificationToQueue(isMobile ? 'default' : getDeviationNotificationQueue(deviation), NotificationType.AddToGroup, notification))];
            case 15:
                _c.sent();
                return [2 /*return*/];
        }
    });
}
export default function groupsRootSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    takeEvery(initGroupsPanel, handleInit),
                    // groups stream is cursor-based, folders stream is offset-based
                    takeEvery(cursorFetchAction, handleFetch),
                    takeEvery(offsetFetchAction, handleFetch),
                    takeLatest(addToGroupFolder, handleAddToGroup),
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}
//# sourceMappingURL=saga.js.map